/**
 * Route prefix for JBF-admin application
 * All routes should be prefixed with this value
 */
export const ROUTE_PREFIX = "/jainboarding-admin";

/**
 * Helper function to prefix a route path
 */
export const prefixRoute = (path: string): string => {
  if (path.startsWith(ROUTE_PREFIX)) {
    return path;
  }
  if (path.startsWith("/")) {
    return `${ROUTE_PREFIX}${path}`;
  }
  return `${ROUTE_PREFIX}/${path}`;
};
